var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58763 9.04347C0.5705 11.147 0 13.5068 0 16C0 18.4932 0.5705 20.853 1.58763 22.9565L16 24.3478L30.4124 22.9565C31.4295 20.853 32 18.4932 32 16C32 13.5068 31.4295 11.147 30.4124 9.04347L16 7.65216L1.58763 9.04347Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58813 22.9565C4.17601 28.3084 9.65657 32 15.9999 32C22.3433 32 27.8239 28.3084 30.4118 22.9565H1.58813Z",
    fill: "#496E2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58813 9.0435H30.4118C27.8239 3.69156 22.3433 0 15.9999 0C9.65657 0 4.17601 3.69156 1.58813 9.0435Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7242 13.0742L21.037 14.8832L23.1631 14.1938L21.8482 16.0013L23.1608 17.8103L21.0356 17.1183L19.7207 18.9258L19.7221 16.6908L17.5967 15.9988L19.7228 15.3094L19.7242 13.0742Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1412 20.5218C13.644 20.5218 11.6195 18.4973 11.6195 16C11.6195 13.5028 13.644 11.4783 16.1412 11.4783C16.9199 11.4783 17.6525 11.6751 18.2922 12.0218C17.2887 11.0404 15.9164 10.4348 14.4021 10.4348C11.3285 10.4348 8.83691 12.9264 8.83691 15.9999C8.83691 19.0735 11.3285 21.5651 14.4021 21.5651C15.9165 21.5651 17.2887 20.9594 18.2922 19.9781C17.6525 20.3249 16.9199 20.5218 16.1412 20.5218Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibya);
export default __webpack_public_path__ + "static/media/libya.607b06e6.svg";
export { ForwardRef as ReactComponent };